import { render, staticRenderFns } from "./GiftcardsPage.vue?vue&type=template&id=e1b136a8"
import script from "./GiftcardsPage.vue?vue&type=script&lang=js"
export * from "./GiftcardsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports